import axios, { AxiosError, AxiosRequestTransformer, AxiosResponseTransformer } from 'axios'
import { camelizeKeys, decamelizeKeys } from 'humps'

export interface IndexResponseBase {
  meta: { page: number; perPage: number; totalCount: number; totalPages: number }
}

const transformRequest: AxiosRequestTransformer = (data, headers) => {
  const meta = document.querySelector('meta[name="csrf-token"]')
  if (meta) {
    headers.set('X-CSRF-Token', meta.getAttribute('content'))
  }
  if (data) {
    return decamelizeKeys(data)
  }
  return data
}

const transformResponse: AxiosResponseTransformer = (data) => {
  if (typeof data === 'string') {
    try {
      return camelizeKeys(JSON.parse(data))
    } catch {
      return data
    }
  }
  return camelizeKeys(data)
}

const ApiService = axios.create({
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  withCredentials: true,
  transformRequest: [
    transformRequest,
    ...(axios.defaults.transformRequest as AxiosRequestTransformer[]),
  ],
  transformResponse: [
    ...(axios.defaults.transformResponse as AxiosResponseTransformer[]),
    transformResponse,
  ],
})

// Handle 401 errors globally
ApiService.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      if (window.location.pathname !== '/login') {
        window.location.href = '/login'
      }
    }
    return Promise.reject(error)
  },
)

export default ApiService
